export default __webpack_public_path__ + "_/images/app/app-ru-1477531d2be12693f9c61e90c15d4589f4f4099eb1df3cb67e66bc9b6abae485.png";